import { selectIsAutoProlongChecked } from '../checkoutInfo';
import { IAppState } from './../../types/reducers/state';
import { selectActiveServiceIdIfEnabled } from './selectActiveServiceIdIfEnabled';
import { selectDynamicPrice } from './selectDynamicPrice';
import { selectIsPublicationPaid } from './selectIsPublicationPaid';
import { selectPublishDays } from './selectPublishDays';
import { selectTariffId } from './selectTariffId';

export const selectPublishTermsDataForTracking = (state: IAppState) => {
  return {
    autoprolong: selectIsAutoProlongChecked(state),
    services: selectIsPublicationPaid(state) ? 'paid' : 'free',
    tariffId: selectTariffId(state),
    dynamicPrice: selectDynamicPrice(state),
    daysPublish: selectPublishDays(state),
    dynamicType: selectActiveServiceIdIfEnabled(state) ?? 'off',
  };
};
